// extracted by css-extract-rspack-plugin
export default {"form__validation":"form__validation-fm40hM","formValidation":"form__validation-fm40hM"};